import type { EnrichedVehicleDetails } from '@web/vin-sessions/types';

import { useRecentConnection } from '../hooks/use-recent-connection';
import { useSsm5Connection } from '../hooks/use-ssm5-connection';
import { Ssm5ConnectionOffer } from './ssm5-connection-offer';

/** Props for {@link Ssm5SessionRecentConnection}. */
export type Ssm5SessionRecentConnectionProps = {
    /** The vehicle of the open VIN session. */
    vehicle: EnrichedVehicleDetails;
};

/**
 * The open VIN session's most recent SSM5 connection, ready to reopen through the connect flow. A
 * session still live on this vehicle is offered in its place and reopens without connecting again.
 * Renders nothing without a connection for the session's VIN.
 *
 * @param props - {@link Ssm5SessionRecentConnectionProps}
 * @returns the section, or null when there is nothing to offer
 */
export function Ssm5SessionRecentConnection({ vehicle }: Ssm5SessionRecentConnectionProps) {
    const { liveConnection } = useSsm5Connection();
    const recentConnection = useRecentConnection(vehicle.vinRecord.vin);
    const live = liveConnection?.vin === vehicle.vinRecord.vin ? liveConnection : undefined;

    return <Ssm5ConnectionOffer live={live} recentConnection={recentConnection} vehicle={vehicle} />;
}
